import { createPostEndpoint } from '@sonar-software/sonar-http';

export const postDataSecurityMonitoredObjects = createPostEndpoint(
	'/api/v3/data-security/management/monitored-entity-definitions/default'
);
